module.exports = __webpack_public_path__ + "fonts/Poppins-SemiBold.6f1520d1.ttf";